'use client'

import { Button, Divider, Spacer } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/shared/i18n'

type Props = {
  feedbacks_path: string
}

const FaqFeedbackFormLink = ({ feedbacks_path }: Props) => {
  const translate = useTranslate('help_center_feedback.feedback_form_link')

  return (
    <>
      <Divider />
      <Spacer size={Spacer.Size.XLarge} />
      <Button
        url={feedbacks_path}
        text={translate('fill_feedback_form_text')}
        styling={Button.Styling.Filled}
        size={Button.Size.Medium}
        testId="fill-feedback-form-button"
        inline
      />
    </>
  )
}

export default FaqFeedbackFormLink
